import React, { Component }  from 'react';
import {format} from 'react-string-format';
import Game from "./Game";
import * as ReactDOM from 'react-dom';
import {NavLink} from "react-router-dom";
import {withRouter} from "./withRouter";
import {Container, Row, Col, Button, Card, ListGroup} from 'react-bootstrap';
import { TwitterShareButton, TwitterIcon } from 'react-share';

class Games extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            items: [],
            page: 1,
            pages: 1,
            sort: "es_index",
            sort_direction: "desc",
            filters: {
                "status": ['active'],
                "os": [],
            },
            chats: [],
            isLoadedChats: false,
        };
    }

    componentDidMount() {
        this.loadGames();

        fetch(`${process.env.REACT_APP_API_URL}/chat/all`)
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isChatsLoaded: true,
                        chats: result.chats,
                    });
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.setState({
                        isChatsLoaded: true,
                        error
                    });
                }
            )
    }

    async loadGames(){
        console.log(this.state);

        await fetch(`${process.env.REACT_APP_API_URL}/customer/game?sort=`
            + this.state.sort
            + `&sort_direction=`+this.state.sort_direction
            + `&page=`+this.state.page
            + `&filters[status]=`+JSON.stringify(this.state.filters.status)
            + `&filters[os]=`+JSON.stringify(this.state.os),
        )
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoaded: true,
                        items: result.data,
                        pages: result.pagination.pages
                    });
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }

    async indexGames(e){
        e.preventDefault();

        let sortKey = e.target.sortKey.value;

        let statuses = [];

        if (e.target.active_status.checked){
            statuses.push('active');
        }

        if (e.target.demo_status.checked){
            statuses.push('demo');
        }

        if (e.target.in_review_status.checked){
            statuses.push('in_review');
        }

        if (e.target.in_review_status.checked){
            statuses.push('in_review');
        }

        if (e.target.update_in_review_status.checked){
            statuses.push('update_in_review');
        }

        if (e.target.ready_for_review_status.checked){
            statuses.push('ready_for_review');
        }

        let os = [];

        if (e.target.os_android.checked){
            os.push('android_file_url');
        }

        if (e.target.os_ios.checked){
            os.push('ios_file_url');
        }

        if (e.target.os_mac.checked){
            os.push('mac_file_url');
        }

        if (e.target.os_windows.checked){
            os.push('windows_file_url');
        }

        this.setState(prevState => ({
            sort: sortKey,
            sort_direction: 'desc',
            isLoaded: false,
            items: [],
            filters: {
                'os': os,
                'status': statuses,
            }
        }), this.loadGames);
    }

    async nextPage(e){
        e.preventDefault();

        this.setState(prevState => ({
           page: prevState.page >= prevState.pages ? 0 : prevState.page + 1,
            isLoaded: false,
            items: [],
        }), this.loadGames);
    }

    async prevPage(e){
        e.preventDefault();

        this.setState(prevState => ({
            page: prevState.page > 1 ? prevState.page - 1 : 1,
            isLoaded: false,
            items: [],
        }), this.loadGames);
    }


    handleSearch(e) {
        e.preventDefault();

        const {navigate} = this.props;

        navigate('/games/search/'+e.target.search.value);
    };

    render() {
        const { error, isLoaded, items, chats } = this.state;
        if (error) {
            return <div>Error: {error.message}</div>;
        } else if (!isLoaded) {
            return <div>Loading...</div>;
        } else {
            var result = (
                <div id="root">
                    {/*<form onSubmit={this.handleSearch.bind(this)}>
                        <input type="text" placeholder="Search..." name="search" />
                        <input type="submit" value="Submit"/>
                    </form>*/}
                    {items.map(item => (
                        <div>
                            <Card style={{ width: '100%' }}>
                                <Card.Img width="100%" height="auto" variant="top" src={item.game_page ? item.game_page.background_image_url : ''} />
                                <Card.ImgOverlay>
                                    <img style={{
                                        borderRadius: 5,
                                        borderWidth: 5,
                                        borderColor: "white",
                                        backgroundColor: "white",
                                        paddingTop: 2,
                                        paddingLeft: 2,
                                        paddingBottom: 2,
                                        paddingRight: 2,
                                        marginTop: "20%"
                                    }} height="20%" src={item.game_page ? item.game_page.icon_url : ''} />
                                </Card.ImgOverlay>
                                <Card.Body>
                                    <Card.Title>
                                        {item.name} {item.status !== 'active' ?
                                        <span style={{
                                            float: "right",
                                            backgroundColor: "#ffea2b",
                                            color: "#faf19d",
                                            borderRadius: 5,
                                            fontWeight: "bold",
                                            capacity: 1,
                                            padding: 10,
                                        }}>
                                            {item.status.replace('_', ' ').replace('_', ' ')}
                                        </span>
                                        : <empty/>
                                    }
                                    </Card.Title>
                                    <Card.Text>
                                        <img src="https://cdn-icons-png.flaticon.com/512/2636/2636869.png" width="30px"/>
                                        <span style={{
                                            fontSize: 20
                                        }}>{item.es_index}</span>
                                    </Card.Text>
                                </Card.Body>
                                <ListGroup className="list-group-flush">
                                    <ListGroup.Item>{item.genre} from {item.publisher.name}</ListGroup.Item>
                                    <ListGroup.Item>{item.game_category ? "Category: " + item.game_category.name : ""}</ListGroup.Item>
                                    <ListGroup.Item>
                                        <NavLink
                                            to={"/games/" + item.id.toString()}
                                            style={{
                                                marginRight: 10
                                            }}
                                            className={({ isActive }) => (isActive ? 'btn btn-warning' : 'btn btn-warning')}
                                        >
                                            More
                                        </NavLink>
                                        <NavLink
                                            style={{
                                                marginRight: 10
                                            }}
                                            className={({ isActive }) => (isActive ? 'btn btn-primary' : 'btn btn-primary')}
                                        >
                                            <TwitterShareButton
                                                url={"https://easy-street.herokuapp.com/games/" + item.id.toString()}
                                                quote={item.name}
                                                hashtag="#easystreet"
                                            >
                                                Share
                                            </TwitterShareButton>
                                        </NavLink>
                                        <NavLink
                                            to={"/games/" + item.id.toString()}
                                            className={({ isActive }) => (isActive ? 'btn btn-success' : 'btn btn-success')}
                                        >
                                            Download
                                        </NavLink>
                                    </ListGroup.Item>
                                </ListGroup>
                            </Card>
                            <br/><br/>
                        </div>
                    ))}
                </div>
            );

            return <Container>
                <br/>
                <Row style={{flexDirection: 'row', justifyContent: 'flex-end'}}>
                    <Col>
                        <div class="alert alert-dark">
                            <center>
                                <button className="btn btn-dark" id='chat-open-button' onClick={(e) => {
                                    let block = document.getElementById('filtersContent');

                                    if (block.style.display === 'none') {
                                        block.style.display = 'block';
                                    } else {
                                        block.style.display = 'none';
                                    }
                                }}>Filters
                                </button>
                            </center>
                            <br/>
                        <div style={{
                            display: "none"
                        }} class="justify-content-center" id="filtersContent">
                            <form onSubmit={this.indexGames.bind(this)}>
                            <div class="row justify-content-center">
                                <div class="alert alert-light col-sm">
                                    <div className="row justify-content-center" id="range-example-filters"
                                         data-mdb-items=".range-example-item" data-mdb-auto-filter="false">
                                        <div className="col-md-12 mt-3">
                                            <input className="form-check-input" type="checkbox" defaultChecked={false}
                                                   name="os_android" />
                                            <label className="form-check-label" htmlFor="create_new">Android</label>
                                            <br/>

                                            <input className="form-check-input" type="checkbox" defaultChecked={false}
                                                   name="os_ios" />
                                            <label className="form-check-label" htmlFor="create_new">iOS</label>
                                            <br/>

                                            <input className="form-check-input" type="checkbox" defaultChecked={false}
                                                   name="os_windows" />
                                            <label className="form-check-label" htmlFor="create_new">Windows</label>
                                            <br/>

                                            <input className="form-check-input" type="checkbox" defaultChecked={false}
                                                   name="os_mac" />
                                            <label className="form-check-label" htmlFor="create_new">MacOS</label>
                                            <br/>

                                            <input className="form-check-input" type="checkbox" defaultChecked={false}
                                                   name="os_other" />
                                            <label className="form-check-label" htmlFor="create_new">Other</label>
                                            <br/>

                                        </div>
                                    </div>
                                </div>
                                <div className="alert alert-light col-sm ms-2">
                                    <div className="row justify-content-center" id="range-example-filters"
                                         data-mdb-items=".range-example-item" data-mdb-auto-filter="false">
                                        <div className="col-md-12 mt-3">
                                            <input className="form-check-input" type="checkbox" defaultChecked={true}
                                                   name="active_status" />
                                            <label className="form-check-label" htmlFor="create_new">Active</label>
                                            <br/>

                                            <input className="form-check-input" type="checkbox" defaultChecked={false}
                                                   name="demo_status" />
                                            <label className="form-check-label" htmlFor="create_new">Demo</label>
                                            <br/>

                                            <input className="form-check-input" type="checkbox" defaultChecked={false}
                                                   name="in_review_status" />
                                            <label className="form-check-label" htmlFor="create_new">In review</label>
                                            <br/>

                                            <input className="form-check-input" type="checkbox" defaultChecked={false}
                                                   name="ready_for_review_status" />
                                            <label className="form-check-label" htmlFor="create_new">Ready for review</label>
                                            <br/>

                                            <input className="form-check-input" type="checkbox" defaultChecked={true}
                                                   name="update_in_review_status" />
                                            <label className="form-check-label" htmlFor="create_new">Update in review</label>
                                            <br/>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br/>
                            <div id="sortBox">
                                <h4>Sorting</h4>
                                <select class="form-select mb-3" id="sort" aria-label=".form-select-lg example" name="sortKey">
                                    <option value="es_index">Fan Favourites First</option>
                                    <option value="downloads">Most Downloaded First</option>
                                    <option value="likes">High Rated First</option>
                                    <option value="id" >Newly Published First</option>
                                </select>
                            </div>
                            <div>
                                <center>
                                    <input name="submit" type="submit" className="btn btn-light" value="Save"/>

                                    <a href="/games" className="btn btn-dark ms-2">Reset</a>
                                </center>
                            </div>
                            </form>
                        </div>
                        </div>

                        <br/>
                        <div class="alert alert-dark">
                            <center><h3>Highest activity</h3></center>
                            {chats.map(item => (
                                <div align="left">
                                    <div class="row">
                                        <a class="col-sm" style={{
                                            textDecoration: "none"
                                        }} href={"/games/" + item.game.id.toString()}>
                                            <h4>{item.game.name}</h4>

                                            <img width="80" style={{
                                                borderRadius: 5
                                            }} src={item.game.game_page ? item.game.game_page.icon_url : "#"}></img>

                                        </a>

                                        <div class="col-sm" style={{
                                            float: "right"
                                        }}>
                                            <div style={{
                                                backgroundColor: "#fcec88",
                                                borderRadius: 15,
                                                paddingInline: 10,
                                                paddingBlock: 10,

                                            }} >
                                                On Easy Street from {(new Date(item.game.created_at)).toDateString()}
                                            </div>

                                            <div style={{
                                                backgroundColor: "#b3ccff",
                                                borderRadius: 15,
                                                paddingInline: 10,
                                                paddingBlock: 10,
                                                width: 200,
                                                float: "right"
                                            }}>
                                                {item.messages_count} {item.messages_count > 1 ? "messages" : "message"}
                                            </div>
                                        </div>
                                    </div>
                                    <br/>
                                </div>
                            ))}
                        </div>
                    </Col>

                    <Col className="ms">
                            {result}
                        <center>

                            {this.state.page > 1 ?
                                <div className="btn-group">
                                    <button onClick={this.prevPage.bind(this)} type="button" className="btn btn btn-outline-secondary">
                                        Prev
                                    </button>
                                    <button onClick={this.nextPage.bind(this)} type="button" className="btn btn btn-secondary">
                                        Next
                                    </button>
                                </div>
                                :
                                <button onClick={this.nextPage.bind(this)} type="button" className="btn btn btn-secondary">
                                    Next
                                </button>
                            }
                        </center>
                    </Col>
                </Row>
            </Container>
        }
    }
}

export default withRouter(Games);
